import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../environments/environments';
import { EncryptionService } from './Encryption/encryption.service';

@Injectable({
  providedIn: 'root',
})
export class EPassPrinterService implements OnInit, OnDestroy {
  ePosPrinter: any | null = null;
  ePosBuilder: any | null = null;
  allowdPrinterIP = environment.AllowdPrinterIP;
  orgId: string = null;

  constructor(private encryptionService: EncryptionService) {}

  ngOnInit(): void {
    this.orgId = this.encryptionService.getCurrentUser().organizationID;
  }

  async initializeEposPrinter(): Promise<void> {
    try {
      await this.loadEposScript();

      // Debugging: Check if epson SDK is available
      console.log('ePOS SDK Object:', (window as any).epson);
      const epson = (window as any).epson;
      // if (!epson || !epson.ePosDevice) {
      //   throw new Error(
      //     'ePosDevice is not available. Ensure the SDK is correctly loaded.'
      //   );
      // }

      // Create ePosDevice instance (Do not use `new` if it's not a constructor)
      const eposDevice = new epson.ePOSDevice();

      await new Promise<void>((resolve, reject) => {
        this.orgId = this.encryptionService.getCurrentUser().organizationID;
        const orgId = this.orgId;
        const ip = (environment.AllowdPrinterIP as { [key: string]: string })[
          orgId
        ];
        eposDevice.connect(ip, 8008, (success: string) => {
        // eposDevice.connect(ip, 8043, (success: string) => {
          if (success === 'OK' || success === 'SSL_CONNECT_OK') {
            eposDevice.createDevice(
              'local_printer',
              eposDevice.DEVICE_TYPE_PRINTER,
              { crypto: false, buffer: false },
              (deviceObj: any, code: string) => {
                if (code === 'OK') {
                  this.ePosPrinter = deviceObj;
                  this.ePosBuilder = epson.ePOSBuilder();
                  // this.printVisitorEPass(this.sampledata);
                  console.log(this.ePosPrinter);
                  console.log(this.ePosBuilder);
                  console.log('Printer initialized successfully');
                  resolve();
                } else {
                  reject(new Error(`Failed to create printer device: ${code}`));
                }
              }
            );
          } else {
            reject(new Error('Failed to connect to the printer'));
          }
        });
      });
    } catch (error) {
      console.error('Error initializing ePOS printer:', error);
    }
  }

  // async printVisitorEPass(visitorData: any): Promise<boolean> {
  //   try {
  //     // Create the canvas element
  //     const canvas = document.createElement('canvas');
  //     const ctx = canvas.getContext('2d');

  //     if (!ctx) {
  //       throw new Error('Failed to get canvas context');
  //     }

  //     // Set canvas dimensions (adjust based on your desired pass size)
  //     const canvasWidth = 400;
  //     const canvasHeight = 600;
  //     canvas.width = canvasWidth;
  //     canvas.height = canvasHeight;

  //     // Set background color and border (optional)
  //     ctx.fillStyle = '#f4f4f4';
  //     ctx.fillRect(0, 0, canvasWidth, canvasHeight);

  //     // Draw a border around the pass (optional)
  //     ctx.strokeStyle = '#000';
  //     ctx.lineWidth = 3;
  //     ctx.strokeRect(0, 0, canvasWidth, canvasHeight);

  //     // Set the font for the header
  //     ctx.font = 'bold 20px Arial';
  //     ctx.textAlign = 'center';
  //     ctx.fillStyle = '#000';
  //     ctx.fillText('Visitor Entry Pass', canvasWidth / 2, 30);

  //     // Visitor Details
  //     ctx.font = '16px Arial';
  //     ctx.textAlign = 'left';
  //     ctx.fillStyle = '#000';
  //     ctx.fillText(`First Name: ${visitorData.firstName}`, 20, 60);
  //     ctx.fillText(`Last Name: ${visitorData.lastName}`, 20, 90);
  //     ctx.fillText(`Email: ${visitorData.email}`, 20, 120);
  //     ctx.fillText(`Phone: ${visitorData.phoneNumber}`, 20, 150);
  //     ctx.fillText(`Meeting With: ${visitorData.hostName}`, 20, 180);
  //     ctx.fillText(`Visit Date: ${visitorData.visitDateTime}`, 20, 210);
  //     ctx.fillText(`Check-in Time: ${visitorData.checkIn}`, 20, 240);
  //     ctx.fillText(`Purpose: ${visitorData.purpose}`, 20, 270);

  //     // Add some space before OTP
  //     const otpStartY = 310;

  //     // OTP (Bold and Big)
  //     ctx.font = 'bold 32px Arial';
  //     ctx.textAlign = 'center';
  //     ctx.fillStyle = '#000';
  //     ctx.fillText(`OTP: ${visitorData.securityKey}`, canvasWidth / 2, otpStartY);

  //     // Add some space after OTP
  //     const photoStartY = otpStartY + 50;

  //     // Load and draw the visitor's photo
  //     const imageUrl = visitorData.profilePicture; // Assuming the photo URL is passed in visitorData
  //     const img = new Image();
  //     img.crossOrigin = 'Anonymous'; // Enable cross-origin
  //     img.src = imageUrl;

  //     await new Promise<void>((resolve, reject) => {
  //       img.onload = () => {
  //         // Draw the image on the canvas (scale to fit within the canvas)
  //         const photoWidth = 150; // Set the width of the photo
  //         const photoHeight = (img.height / img.width) * photoWidth; // Maintain aspect ratio
  //         const photoX = (canvasWidth - photoWidth) / 2; // Center the photo
  //         const photoY = photoStartY;
  //         ctx.filter = 'brightness(2) contrast(2)';
  //         ctx.drawImage(img, photoX, photoY, photoWidth, photoHeight);

  //         resolve();
  //       };

  //       img.onerror = (error) => {
  //         reject(new Error('Failed to load image'));
  //       };
  //     });

  //     // Once everything is drawn on the canvas, send it to the printer
  //     this.ePosPrinter.addImage(ctx, 0, 0, canvasWidth, canvasHeight);
  //     this.ePosPrinter.addFeedLine(2);

  //     // Cut and send to printer
  //     this.ePosPrinter.addCut(this.ePosPrinter.CUT_FEED);
  //     this.ePosPrinter.send();
  //     console.log('E-Pass printed successfully');
  //     return true;
  //   } catch (error) {
  //     console.error('Error printing E-Pass:', error);
  //     return false;
  //   }
  // }

  async printVisitorEPass(visitorData: any): Promise<boolean> {
    try {
      if (!this.ePosPrinter) {
        await this.initializeEposPrinter();
      }
      // Print header
      this.ePosPrinter.addTextAlign(this.ePosPrinter.ALIGN_CENTER);
      this.ePosPrinter.addTextSize(2, 2);
      this.ePosPrinter.addText('Visitor Details\n\n');

      // Visitor details (sample values)
      this.ePosPrinter.addTextAlign(this.ePosPrinter.ALIGN_LEFT);
      this.ePosPrinter.addTextSize(1, 1);
      this.ePosPrinter.addText(`First Name: ${visitorData.firstName}\n`);
      this.ePosPrinter.addText(`Last Name: ${visitorData.lastName}\n`);
      this.ePosPrinter.addText(`Email: ${visitorData.email}\n`);
      this.ePosPrinter.addText(`Phone: ${visitorData.phoneNumber}\n`);
      this.ePosPrinter.addText(`Meeting With: ${visitorData.hostName}\n`);
      this.ePosPrinter.addText(
        `Visit Date: ${new Date(
          visitorData.visitDateTime
        ).toLocaleDateString()}\n`
      );
      // this.ePosPrinter.addText(`Check-in Time: ${visitorData.checkIn}\n`);
      this.ePosPrinter.addText(
        `Check-in Time: ${new Date().toLocaleString()}\n`
      );
      this.ePosPrinter.addText(`Purpose: ${visitorData.purpose}\n`);
      this.ePosPrinter.addFeedLine(1);

      // OTP (Big and Bold)
      this.ePosPrinter.addTextAlign(this.ePosPrinter.ALIGN_CENTER);
      this.ePosPrinter.addTextSize(3, 3);
      this.ePosPrinter.addText(`OTP: ${visitorData.securityKey}\n`);
      this.ePosPrinter.addFeedLine(2);
      // this.ePosPrinter.addLogo(32, 32);

      // Load and print the uploaded photo
      const imageUrl = visitorData.profilePicture; // Assuming the photo URL is passed in visitorData
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // Enable cross-origin
      img.src = imageUrl;

      if (imageUrl) {
        await new Promise<void>((resolve, reject) => {
          img.onload = () => {
            // Create the canvas element
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (!ctx) {
              reject(new Error('Failed to get canvas context'));
              return;
            }

            // Set canvas dimensions to the image dimensions (optional scaling if needed)
            const maxWidth = 300; // For example, limit the image width to 300px for printing
            const scale = img.width > maxWidth ? maxWidth / img.width : 1;
            canvas.width = img.width * scale;
            canvas.height = img.height * scale;
            ctx.filter = 'brightness(2) contrast(2)';

            // Draw the image onto the canvas with scaling
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Send the image to the printer
            this.ePosPrinter.addImage(ctx, 0, 0, canvas.width, canvas.height);
            this.ePosPrinter.addFeedLine(2);
            resolve();
          };
          img.onerror = (error) => {
            reject(new Error('Failed to load image'));
          };
        });
      }

      // Cut and send to printer
      this.ePosPrinter.addCut(this.ePosPrinter.CUT_FEED);
      this.ePosPrinter.send();
      console.log('E-Pass printed successfully');
      return true;
    } catch (error) {
      console.error('Error printing E-Pass:', error);
      return false;
    }
  }

  /* // Function to generate a dummy monochrome image byte array
  private generateImageArray(width: number, height: number): Uint8Array {
    const bytesPerRow = Math.ceil(width / 8);
    const imageData = new Uint8Array(bytesPerRow * height);

    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const isBlack = (x + y) % 10 < 5; // Creates a simple pattern
        const byteIndex = Math.floor(x / 8) + y * bytesPerRow;
        const bitIndex = 7 - (x % 8);
        if (isBlack) {
          imageData[byteIndex] |= 1 << bitIndex;
        }
      }
    }
    return imageData;
  }
  private loadMonochromeBitmap(
    url: string,
    callback: (monoBitmap: Uint8Array, width: number, height: number) => void
  ): void {
    let img: HTMLImageElement = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    img.onload = function (): void {
      let canvas: HTMLCanvasElement = document.createElement('canvas');
      const width = 300;
      const height = 150;
      canvas.width = width;
      canvas.height = height;
      let ctx: CanvasRenderingContext2D | null = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0, width, height);
        let imageData: ImageData = ctx.getImageData(0, 0, width, height);
        let pixels = imageData.data;
        let monoBitmap = new Uint8Array((width * height) / 8);

        for (let y = 0; y < height; y++) {
          for (let x = 0; x < width; x++) {
            let i = (y * width + x) * 4;
            let grayscale = (pixels[i] + pixels[i + 1] + pixels[i + 2]) / 3;
            let bit = grayscale < 128 ? 1 : 0;
            let byteIndex = (y * width + x) >> 3;
            let bitIndex = 7 - (x % 8);
            monoBitmap[byteIndex] |= bit << bitIndex;
          }
        }
        callback(monoBitmap, width, height);
      }
    };
  }
  public loadImageBase64(
    url: string,
    callback: (base64Image: string) => void
  ): void {
    let img: HTMLImageElement = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    img.onload = function (): void {
      let canvas: HTMLCanvasElement = document.createElement('canvas');
      canvas.width = 300; // Set fixed width for the printer
      canvas.height = 150; // Set fixed height for the printer
      let ctx: CanvasRenderingContext2D | null = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        let dataURL: string = canvas
          .toDataURL('image/png')
          .replace(/^data:image\/png;base64,/, '');
        callback(dataURL);
      }
    };
  }

  // private getBase64Image(url: string): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     const img: HTMLImageElement = new Image();
  //     img.crossOrigin = 'Anonymous';
  //     img.src = url;
  //     img.onload = (): void => {
  //       const canvas: HTMLCanvasElement = document.createElement('canvas');
  //       canvas.width = img.width;
  //       canvas.height = img.height;
  //       const ctx: CanvasRenderingContext2D | null = canvas.getContext('2d');
  //       if (!ctx) {
  //         reject(new Error('Failed to get canvas 2D context'));
  //         return;
  //       }
  //       ctx.drawImage(img, 0, 0);
  //       try {
  //         const dataURL: string = canvas
  //           .toDataURL('image/png')
  //           .replace(/^data:image\/png;base64,/, '');
  //         resolve(dataURL);
  //       } catch (error) {
  //         reject(new Error('Error converting image to Base64'));
  //       }
  //     };
  //     img.onerror = (): void => {
  //       reject(new Error('Failed to load image: ' + url));
  //     };
  //   });
  // }
  // Function to convert image to Base64
  private getBase64Image(
    url: string,
    callback: (base64Image: string) => void
  ): void {
    let img: HTMLImageElement = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    img.onload = function (): void {
      let canvas: HTMLCanvasElement = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      let ctx: CanvasRenderingContext2D | null = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0);
        let dataURL: string = canvas
          .toDataURL('image/png')
          .replace(/^data:image\/png;base64,/, '');
        callback(dataURL);
      }
    };
  } */

  private loadEposScript(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const scriptUrl = 'assets/epson-sdk.js'; // Corrected path

      // Check if the SDK is already loaded
      if (
        (window as any).ePOS_SDK ||
        document.querySelector(`script[src="${scriptUrl}"]`)
      ) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = scriptUrl;
      script.type = 'text/javascript';
      script.async = true;

      script.onload = () => {
        console.log('ePOS SDK loaded successfully');
        resolve();
      };

      script.onerror = () => {
        console.error('Failed to load ePOS SDK');
        reject(new Error('Failed to load ePOS SDK'));
      };

      document.head.appendChild(script);
    });
  }

  ngOnDestroy() {
    this.ePosPrinter?.clearCommandBuffer();
  }
}
interface EposPrinter {
  addTextAlign(align: number): void;
  addTextSize(width: number, height: number): void;
  addText(text: string): void;
  addTextStyle(
    reverse: boolean,
    underline: boolean,
    bold: boolean,
    color: boolean
  ): void;
  addFeedLine(lines: number): void;
  addImage(
    buffer: any,
    x: number,
    y: number,
    width: number,
    height: number,
    color: number,
    mode: number
  ): void;
  addHLine(x1: number, x2: number, style: number): void;
  add(data: string): void;
  clearCommandBuffer(): void;
  addCut(type: number): void;
  send(): void;
}

interface EposBuilder {
  ALIGN_LEFT: number;
  ALIGN_CENTER: number;
  ALIGN_RIGHT: number;
  HW_INIT: string;
  LINE_MEDIUM: number;
  CUT_FEED: number;
  COLOR_1: number;
  MODE_MONO: number;
}
